import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { ReactComponent as Email } from "../assets/icons/Email.svg";
import EmailModal from "./EmailModal";

export default function EmailButton({ show = true, mail: initialMail = {}, showMessage = true}) {
    const [showModal, setShowModal] = useState(false);
    const [mail, setMail] = useState({
        to: [],
        cc: [],
        bcc: [],
        message: null,
        attachments: [],
        ...initialMail,
    });

    useEffect(() => {
        setMail((prev) => {
            return { ...prev, ...initialMail };
        });
    }, [initialMail]);

    const onOpen = () => {
        setShowModal(true)

        if (mail.onMailOpen) {
            mail.onMailOpen();
        }
    }

    if (!show) return null;

    return (
        <>
            <Button type="primary" className="icon-button btn-filled" icon={<Email />} onClick={onOpen}>
                Send
            </Button>
            <EmailModal mail={mail} showModal={showModal} setShowModal={setShowModal} />
        </>
    );
}
